import { type FC, type ReactNode } from "react";
import clsx from "clsx";
import "./DashboardSectionHeader.scss";

interface DashboardSectionHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  actionsClassName?: string;
  className?: string;
  sticky?: boolean;
  divider?: boolean;
}

const DashboardSectionHeader: FC<DashboardSectionHeaderProps> = ({
  title,
  subtitle,
  actions,
  actionsClassName,
  className,
  sticky = false,
  divider = true,
}) => (
  <div
    className={clsx(
      "dashboard-section-header",
      sticky && "dashboard-section-header--sticky",
      !divider && "dashboard-section-header--no-divider",
      className
    )}
  >
    <div className="dashboard-section-header__main">
      <div className="dashboard-section-header__copy">
        <h2 className="dashboard-section-header__title">{title}</h2>
        {subtitle ? (
          <p className="dashboard-section-header__subtitle">{subtitle}</p>
        ) : null}
      </div>
      {actions ? (
        <div
          className={clsx(
            "dashboard-section-header__actions",
            actionsClassName
          )}
        >
          {actions}
        </div>
      ) : null}
    </div>
  </div>
);

export default DashboardSectionHeader;
